module.exports = __webpack_public_path__ + "static/media/SSHRegistrationSplashscreen.4e25de29.svg";